// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'e67e5aaa-bd24-41f4-b143-5867ae85a43e',
      type: 'Container',
      name: 'root',
      className: 'props_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        props: {
          eventMode: 'none'
        }
      },
      interactiveChildren: false
    },
    {
      id: '6ced1808-8886-4bf4-8012-5567372959a9',
      type: 'Sprite',
      name: 'node',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Node',
      parent: 'e67e5aaa-bd24-41f4-b143-5867ae85a43e',
      stateByName: {
        reached: {
          texture: 'Green_Node',
          scale: {
            x: 1,
            y: 1
          }
        },
        claimed: {
          texture: 'Green_Node',
          scale: {
            x: 1,
            y: 1
          }
        }
      }
    },
    {
      id: '3ab99e05-efcd-4009-93a8-b15dd515dbaa',
      type: 'Container',
      name: 'partFxSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e67e5aaa-bd24-41f4-b143-5867ae85a43e'
    },
    {
      id: '8c8aa507-aa77-43e3-b6f8-0be58ec3e379',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: 2,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2',
      localize: false,
      maxWidth: 58,
      maxHeight: 68,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#004dcb',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#004dcb',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e67e5aaa-bd24-41f4-b143-5867ae85a43e',
      stateByName: {
        reached: {
          style: {
            stroke: '#00700e',
            dropShadowColor: '#00700e'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'reached',
    'claimed'
  ],
  handleResize: false
} as const;

export class SeasonPassNodeLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  node!: Sprite;
  partFxSlot!: Container;
  levelText!: Text;
  props_SPL!: (Container & { data: typeof raw['list'][0]['data'] })[];
  StateName!: 'reached' | 'claimed';

  constructor() {
    populate(this, raw);
  }
}
